import { c as _c } from "react/compiler-runtime";
import { ApiWaveType } from "@/generated/models/ApiWaveType";
import CreateWaveTypeInputs from "./CreateWaveTypeInputs";
export default function CreateWaveType(t0) {
  const $ = _c(4);
  const {
    selected,
    onChange
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <p className="tw-mb-0 tw-text-lg sm:tw-text-xl tw-font-semibold tw-text-iron-50">Wave Type</p>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== onChange || $[2] !== selected) {
    t2 = <div>{t1}<CreateWaveTypeInputs onChange={onChange} selected={selected} /></div>;
    $[1] = onChange;
    $[2] = selected;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}